import AgentsForgeSectionLeft from '../../../../assets/images/agents-forge-section-left.png';
import AgentsForgeSectionRight from '../../../../assets/images/agents-forge-section-right.png';

const ForgeWidgetConfig = {
  heading: 'Build powerful Rovo Agents with Forge',
  description:
    "With Forge for Rovo, you can build Agents highly tuned to your team's unique workflows.",
  buttonLabel: 'Get Started',
  buttonHref:
    'https://developer.atlassian.com/platform/forge/extend-atlassian-products-with-a-forge-rovo-agent/',
  leftImage: AgentsForgeSectionLeft,
  rightImage: AgentsForgeSectionRight,
  buttonAriaLabel: 'Get started building with Forge',
};

export default ForgeWidgetConfig;
